import { useState, type FormEvent, type JSX } from 'react';
import { Link } from 'react-router-dom';
import { api } from '../api.js';
import { Icon, Logo } from '../components/Icon.js';
import { BRAND } from '../branding.js';

export function ForgotPassword(): JSX.Element {
  const [email, setEmail] = useState('');
  const [busy, setBusy] = useState(false);
  const [sent, setSent] = useState(false);

  const onSubmit = async (e: FormEvent): Promise<void> => {
    e.preventDefault();
    setBusy(true);
    try {
      await api.forgotPassword(email);
      setSent(true);
    } catch {
      setSent(true);
    } finally {
      setBusy(false);
    }
  };

  return (
    <div
      style={{
        minHeight: '100vh',
        display: 'grid',
        placeItems: 'center',
        background: 'var(--bg)',
        padding: 20,
      }}
    >
      <div style={{ width: 380, maxWidth: '100%' }}>
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            gap: 10,
            marginBottom: 24,
            justifyContent: 'center',
          }}
        >
          <Logo size={28} />
          <div style={{ fontWeight: 600, fontSize: 17, letterSpacing: -0.3 }}>{BRAND.name}</div>
        </div>
        <div className="card" style={{ padding: 28 }}>
          <h2 style={{ margin: '0 0 4px', fontSize: 19, fontWeight: 600, letterSpacing: -0.3 }}>
            Сброс пароля
          </h2>
          <p style={{ margin: '0 0 20px', color: 'var(--fg-subtle)', fontSize: 13 }}>
            {sent
              ? 'Если такой аккаунт существует — письмо с инструкцией отправлено.'
              : 'Введите email, мы пришлём ссылку для сброса.'}
          </p>
          {!sent && (
            <form onSubmit={onSubmit} className="stack">
              <div className="field">
                <label className="field-label">Email</label>
                <div className="field-prefix">
                  <span className="prefix-txt" style={{ paddingLeft: 10, paddingRight: 8 }}>
                    <Icon name="mail" size={13} />
                  </span>
                  <input
                    className="input"
                    type="email"
                    required
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    autoFocus
                  />
                </div>
              </div>
              <button
                className="btn btn-primary"
                type="submit"
                disabled={busy}
                style={{ justifyContent: 'center', marginTop: 6 }}
              >
                {busy ? 'Отправляем…' : 'Отправить ссылку'}
              </button>
            </form>
          )}
          <div style={{ textAlign: 'center', marginTop: 16 }}>
            <Link
              to="/login"
              style={{
                fontSize: 13,
                color: 'var(--fg-subtle)',
                textDecoration: 'none',
              }}
            >
              ← Вернуться ко входу
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
}
